module.exports = __webpack_public_path__ + "static/media/apartment4.89477d05.psd";